import React from 'react';

import Error from '@clearkit/icons/glyphs/Error';
import Checkmark from '@clearkit/icons/glyphs/Checkmark';
import CKTextField from './CKTextField';
import CKMultilineTextField from './CKMultilineTextField';

const SuccessIcon = <Checkmark className="text-green-500" />;
const ErrorIcon = <Error className="text-red-500" />;

export { CKTextField, CKMultilineTextField, SuccessIcon, ErrorIcon };
